import { TENANT_ID } from "Constants/tenant";
import AuthStoreModel from "./models/auth";
import AppStoreModel from "./models/app";
import ErrorModel from "./models/error";
import { RuleStoreModel } from "./models/rules";

const Store = {
  auth: AuthStoreModel,
  app: AppStoreModel,
  error: ErrorModel,
  rules: RuleStoreModel,
};

export const ConfigureStore = {
  name: `renttracking-vektora-${TENANT_ID}-store`,
};

export default Store;
